export const SECRET_KEY = "1054969780046608902197477251393032344695696969796449886332099895";
